import type { HTTPError } from 'ky';

import type { ToastMessage } from '~/components/Toast';
import { HttpStatusCode } from '~settings/api/lib/types';

export const getErrorMessage = async (
  error: HTTPError,
  isCreate = false,
): Promise<ToastMessage> => {
  const status = error?.response?.status as HttpStatusCode;

  switch (status) {
    case HttpStatusCode.EntityConflict:
      return {
        title: 'user.errors.userAlreadyExistsTitle',
        description: 'user.errors.userAlreadyExistsMessage',
      };
    case HttpStatusCode.Forbidden:
      if (isCreate) {
        return {
          title: 'user.errors.noPermissionTitle',
          description: 'user.errors.noPermissionCreateMessage',
        };
      }

      return {
        title: 'user.errors.noPermissionTitle',
        description: 'user.errors.noPermissionEditMessage',
      };

    case HttpStatusCode.BadRequest:
      return {
        title: 'user.errors.validationErrorTitle',
        description: 'user.errors.validationErrorMessage',
      };
    // @ts-expect-error fallthrough to default
    case HttpStatusCode.UnprocessableEntity: {
      const response: { message: string } = await error.response.json();

      // if labels/label groups were not selected
      if (
        response?.message &&
        /role\s.+least\sone\sresource/i.test(response.message)
      ) {
        return {
          title: 'user.errors.resourcesRequiredTitle',
          description: 'user.errors.resourcesRequiredMessage',
        };
      }
      // fallthrough to default
    }
    case HttpStatusCode.NotFound:
    case HttpStatusCode.Unauthorized:
    case HttpStatusCode.InternalServerError:
    default:
      if (isCreate) {
        return {
          title: 'user.errors.userCreateTitle',
          description: 'user.errors.userCreateMessage',
        };
      }

      return {
        title: 'user.errors.userEditTitle',
        description: 'user.errors.userEditMessage',
      };
  }
};
